module.exports = __webpack_public_path__ + "img/edit-blue-icon.f638fe19.svg";